import * as ResultsError from './components/ResultsError.css';
const defaultTheme = {
    ResultsError
};
export default defaultTheme;
